module.exports = __webpack_public_path__ + "static/media/Banette_gaussian2.cd3a22b5.png";